module.exports = __webpack_public_path__ + "static/img/CO2Placard.fda770c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CO2Placard.png
// module id = 120
// module chunks = 1